module.exports = __webpack_public_path__ + "static/img/banner2.4edb9da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner2.jpg
// module id = YdqA
// module chunks = 127